module.exports = __webpack_public_path__ + "img/tenet_icon_cheng@2x.5981dc68.png";